import * as h from '../helpers/helpers';
import * as scf from './salesComparisonFunctions';

export function GetSalesCompGeneralInformation() {
	let list = [];
	let comps = global.ptr.compMultList;

	list.push(scf.GetDataSources(comps));
	list.push(scf.GetProximityToSubject(comps));
	list.push(GetUnitsExcludingADUs(comps));
	list.push(GetAccessoryDwellingUnits(comps));
	list.push(GetIncomeGrossBuildingFinishedArea(comps));
	list.push(GetRentControl(comps));
	list.push(scf.GetSalePrice(comps));
	list.push(GetIncomeSaleDate(comps));
	list.push(GetGrossMonthlyRent(comps));
	list.push(GetGrossRentMultiplier(comps));
	list.push(scf.GetSalesSummaryComparableWeight(comps));


	return list;
}

function GetUnitsExcludingADUs(comps) {
	let list = [];
	list.push("Units Excluding ADUs");
	list.push(global.ptr.subDetail.livingUnitExcludingADUCount.toString());

	for (const cp of comps) {
		list.push(cp.propertyDetail.livingUnitExcludingADUCount.toString());
	}

	return list;
}

function GetAccessoryDwellingUnits(comps) {
	let list = [];
	list.push("Accessory Dwelling Units");
	let total = 0;
	let count = global.ptr.subDetail.accessoryDwellingUnitTotalCount;
	total += count;
	list.push(count.toString());

	for (const cp of comps) {
		count = cp.propertyDetail.accessoryDwellingUnitTotalCount;
		total += count;
		list.push(count.toString());
	}

	if (total === 0) return [];
	return list;
}

function GetIncomeGrossBuildingFinishedArea(comps) {
	let list = [];
	list.push("Gross Building Finished Area");
	list.push(global.ptr.subDetail.totalFinishedAreaOfAllLivingUnitsIncludingADUAreaMeasure.ToString());

	let haveData = false;
	for (const cp of comps) {
		let measure = cp.propertyDetail.totalFinishedAreaOfAllLivingUnitsIncludingADUAreaMeasure;
		if (measure.HasValue()) haveData = true;
		list.push(measure.ToString());
	}

	if (!haveData) return [];
	return list;
}

function GetRentControl(comps) {
	let list = [];
	if (global.ptr.subProp.rentalInformationSummary === null) return list;
	list.push("Rent Control");
	list.push(h.toEnumText(global.ptr.subProp.rentalInformationSummary.propertyRentControlStatusType));

	for (const cp of comps) {
		list.push(h.toEnumText(cp.rentalInformationSummary.propertyRentControlStatusType));
	}

	if (h.compListAllEmpty(list)) return [];
	return list;
}

function GetIncomeSaleDate(comps) {
	let list = [];
	list.push("Sale Date");
	list.push("GRAY");

	let haveData = false;
	for (const cp of comps) {
		const date = cp.sales.GetHistoryTransferDate(true);
		if (date) haveData = true;
		let dateFmt = (date) ? date.FormatMDY() : "";
		list.push(dateFmt);
	}

	if (!haveData) return [];
	return list;
}

function GetGrossMonthlyRent(comps) {
	let list = [];
	list.push("Gross Monthly Rent");
	list.push(global.ptr.subProp.rentalInformationSummary.GetActualRent());

	for (const cp of comps) {
		list.push(cp.rentalInformationSummary.GetActualRent());
	}

	return list;
}

function GetGrossRentMultiplier(comps) {
	let list = [];
	list.push("Gross Rent Multiplier");
	list.push("GRAY");

	for (const cp of comps) {
		list.push(cp.comparable.comparableDetail.grossMonthlyRentMultiplierNumber.toString());
	}

	return list;
}

